import { render, staticRenderFns } from "./member.vue?vue&type=template&id=4d30731e&scoped=true"
import script from "./member.vue?vue&type=script&lang=js"
export * from "./member.vue?vue&type=script&lang=js"
import style0 from "./member.vue?vue&type=style&index=0&id=4d30731e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d30731e",
  null
  
)

export default component.exports